<ion-header class="header">
  <span class="heading">{{ 'update_readpower_modal.updateReadPower' | translate }}</span>
</ion-header>
<ion-content>
  <ion-row class="container">
    <ion-col size="6">
      <ion-row class="info">
        <ion-col size="6" class="vendor-info">
          <ion-row class="device-details"
            >{{ connectedVendor | titlecase }} {{ 'update_readpower_modal.plugin' | translate }}</ion-row
          >
          <ion-row class="accepted-range"
            >{{ 'update_readpower_modal.range' | translate }} {{ minimumSupportedRange }} -
            {{ maximumSupportedRange }}</ion-row
          >
        </ion-col>
        <ion-col size="6" class="readpower-container">
          <span class="power-value">{{ readpower }}</span>
        </ion-col>
      </ion-row>
    </ion-col>
    <ion-col size="6">
      <monorepo-number-pad
        [heading]="'update_readpower_modal.value' | translate"
        [count]="readpower"
        [enableDecimal]="false"
        [enablePrevButton]="false"
        [enableNextButton]="false"
        [enableAddOrSub]="true"
        (countValue)="onReadpowerChanged($event)"
      >
      </monorepo-number-pad>
    </ion-col>
  </ion-row>
</ion-content>
<ion-footer>
  <ui-custom-button
    [btnTxt]="'input_app_common.cancel' | translate"
    [buttonType]="'SECONDARY'"
    [buttonHeight]="'50px'"
    (clickEvent)="handleCancel()"
  ></ui-custom-button>
  <ui-custom-button
    [btnTxt]="'update_readpower_modal.update' | translate"
    [buttonType]="'PRIMARY'"
    [buttonHeight]="'50px'"
    (clickEvent)="handleUpdate()"
  ></ui-custom-button>
</ion-footer>
